import { render, staticRenderFns } from "./error.vue?vue&type=template&id=ea0f4bb0"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sseinfo\\src_finreport_xc\\tdinfo-szs-finreport-pc-\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0f4bb0')) {
      api.createRecord('ea0f4bb0', component.options)
    } else {
      api.reload('ea0f4bb0', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=ea0f4bb0", function () {
      api.rerender('ea0f4bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error.vue"
export default component.exports